import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full p-8" }

import Card from '@ui-kit/card/Card';

interface Props {
  title: string;
  noBodyPadding?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PageWrapper',
  props: {
    title: null,
    noBodyPadding: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), {
      title: __props.title,
      class: "h-full",
      "no-body-padding": __props.noBodyPadding
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      "header-right": _withCtx(() => [
        _renderSlot(_ctx.$slots, "header-right")
      ]),
      _: 3
    }, 8, ["title", "no-body-padding"])
  ]))
}
}

})